import { render, staticRenderFns } from "./FileTree.vue?vue&type=template&id=5363bcae&scoped=true&"
import script from "./FileTree.vue?vue&type=script&lang=js&"
export * from "./FileTree.vue?vue&type=script&lang=js&"
import style0 from "./FileTree.vue?vue&type=style&index=0&id=5363bcae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5363bcae",
  null
  
)

export default component.exports